import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {BubbleList, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.scrollToTop,
                'children': '滚动到顶部'
            }),
            _$cc(Button, {
                'ev-click': this.scrollToSixth,
                'children': '定位到第 6 条'
            }),
            _$cc(Button, {
                'ev-click': this.scrollToBottom,
                'children': '滚动到底部'
            }),
            _$cc(Button, {
                'ev-click': this.checkAtBottom,
                'children': '检查是否贴底'
            })
        ], 4, 'bubble-list-demo-methods-actions'),
        _$ce(2, 'div', [
            _$ct('\n        当前状态：'),
            this.get('status')
        ], 0, 'bubble-list-demo-methods-status'),
        _$cc(BubbleList, {
            'ref': (i) => this.listRef = i,
            'className': 'bubble-list-demo-methods-list',
            'items': this.get('items'),
            'roles': this.get('roles')
        }, null, (i) => this.listRef = i)
    ], 4, 'bubble-list-demo-methods');
};